import React, {useContext, useEffect, useState} from 'react';
import Tooltip from './Tooltip';
import {filterData} from './DropdownFilter';
import {handleFilter, isFilterSelected} from '../functions/filter';
import {FilterContext} from '../context/filterContext';
import {getColor} from '../functions/getColor';
import '../../../assests/css/facilityfilter.scss';
import FacilityTypeInfoPopup from './FacilityTypeInfoPopup';
import classNames from 'classnames';

export interface facilityFilterProps{
    facilityTypeData: filterData[],
    currentFilter?: filterData[],
    disableFilter?: boolean
}

export default function FacilityFilter(props: facilityFilterProps) {

    const {facilityTypeData, currentFilter, disableFilter}=props;

    const [filter, setFilter]=useState<filterData[]>([
    ]);

    const {filterContent, setFilterContent} = useContext(FilterContext);
    const [showFacilities, setShowFacilities] = useState(false);

    const handleSelectFilter=(id: number, value: string)=> {
        const temp = handleFilter(id, value, props.facilityTypeData, filter);
        setFilter(temp);
        setFilterContent({...filterContent, 'facilityType': temp});
    }

    const clearFilter=() => {
        setFilter([]);
        setFilterContent({...filterContent, 'facilityType': []});
    };

    useEffect(()=> {
        if (currentFilter) {
            setFilter(currentFilter);
        }
    }, [currentFilter])

    return (
        <div className={classNames('facility-filter-container',
            disableFilter? 'disable-filter': '')}>
            <div className="facility-filter-info"
                onMouseLeave={disableFilter?
                    ()=> null: ()=> setShowFacilities(false)}>
                <span className="facility-filter-text">Faciltity Type</span>
                <FacilityTypeInfoPopup
                    showPopup={showFacilities}
                    setShowPopup={(show) => setShowFacilities(show)}
                    facilityTypeData={facilityTypeData}
                />
                <span className="facility-type-clear" onClick={disableFilter?
                    ()=> null :()=> clearFilter()}>Clear</span>
            </div>
            <div className="facility-filter-options">
                {facilityTypeData.map((facility, index)=> {
                    return (
                        <Tooltip key={`${facility.id}-${index}`} text={facility.abbreviation? facility.abbreviation: ''}>
                        <span className={classNames('facility-type',
                            disableFilter? 'disable-filter': '')}
                            style={{
                                backgroundColor: isFilterSelected(facility.id, filter)? 'rgba(0, 88, 221, 1)' : getColor(facility.id),
                                color: isFilterSelected(facility.id, filter)? '#fff': 'rgba(0, 0, 0, 1)',
                            }}
                            onClick={disableFilter? ()=> null: ()=>
                                handleSelectFilter(facility.id, facility.value)}
                        >{facility.value}</span></Tooltip>
                    );
                })}
            </div>
        </div>
    );

}